import React from "react"
import { Link, graphql } from "gatsby"
import BackgroundImage from 'gatsby-background-image'
import Img from "gatsby-image"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Header from "./../../components/header"
import BadgeItem from "./../../components/BadgeItem"

export default function Hent({ data }) {
  return (
    <Layout>

      <Header title="Retour" href="/" />
      <SEO title="Hent" />

      <div className="banner no-bg">
        <h1>Hent</h1>
        <h2 className="banner-subtitle">Stéphane Lavoué</h2>
      </div>

      {data.allMarkdownRemark.edges.map(({ node }) => (
        <BadgeItem
          key={node.id}
          to={node.fields.slug}
          img={node.frontmatter.img}
          title={node.frontmatter.title}
          subtitle={'Extrait audio — ' + node.frontmatter.duree}
        />
      ))}

    </Layout>
  )
}

export const query = graphql`
  query {
    file(relativePath: { eq: "hent/hent-bg.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
        fixed(height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    allMarkdownRemark(
        sort: { fields: [frontmatter___title], order: ASC },
        filter: {
          fields: {slug: { regex: "/^\\/hent/" }}
        }
      )
    {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            duree
            img {
              ...BadgeImage
            }
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`
